webpackJsonp([1],{

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(97);


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/// <amd-dependency path="jqueryplugins"/>
/// <amd-dependency path="knockoutplugins"/>
/// <amd-dependency path="modules"/>
/// <amd-dependency path="kendo"/>
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(27), __webpack_require__(34), __webpack_require__(65), __webpack_require__(17)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, $, tools) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    console.log("Index - ALL MODULES LOADED");
    $(function () {
        $.ajaxSetup({
            complete: function (xhr) {
                if (xhr.responseJSON && xhr.responseJSON.Error === "SessionExpired") {
                    //var currentUrl = window.location.pathname;
                    window.location.href = "/Account/LogOff?LogOff=autoLogOff";
                }
                if (xhr.responseJSON && xhr.responseJSON.Error === "Forbidden") {
                    tools.error("You don't have permissions to view this content");
                }
                if (xhr.responseJSON && xhr.responseJSON.Error && !xhr.responseJSON.Success) {
                    tools.error(xhr.responseJSON.Error);
                }
            },
            error: function (data) {
                console.log("failed", data);
            }
        });
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=index.js.map

/***/ })

},[96]);


// WEBPACK FOOTER //
// app.bundle.js